;(function ( $, window, document, undefined ) {



    var pluginName = 'beMessaging',
        defaults = {
            apiUrl: window.location.origin,
            locale: 'es'
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend( {}, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;
        this.container = this.$element.find($('.p-messaging--container'));

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;
        Plugin.container.removeClass('hide');
        Plugin.container.scrollTop(Plugin.container[0].scrollHeight);
        Plugin.loadMessages();

    };

    Plugin.prototype.loadMessages = function(){
        var Plugin = this;
        timer = setTimeout(function () {
            Plugin.getData();
            Plugin.loadMessages();
        }, 15000);


    };

    Plugin.prototype.getData = function () {
        var Plugin = this;
        $.ajax({
            url: window.location.origin + '/mensajes',
            type: 'GET',
            success: function (data) {
                Plugin.loadTemplate(data);
            },
            error: function (data) {
                console.error('Error')
            }
        });
    };


    Plugin.prototype.loadTemplate = function (dataMessages) {
        var Plugin = this;
        var rows = [];
        var templateData;

        $.get(window.location.origin + '/mensajes/mensaje-template-dia').success(function(data) {
            templateData = $.templates(data);


        $.get(window.location.origin + '/mensajes/mensaje-template').success(function(data) {

            var scrollAtBottom = true;

            if((Plugin.container[0].scrollHeight - Plugin.container.scrollTop() > Plugin.container.height())){
                scrollAtBottom = false;
            }
            var day = null;
            $.each(dataMessages,function(key,value){
                if(value.day != day){
                    var tmpHtmlDate = templateData.render(value);
                    var newRowDate = $(tmpHtmlDate);
                    rows.push(newRowDate);
                    day = value.day;
                }
                    var template = $.templates(data);
                    var tmpHtml = template.render(value);
                    var newRow = $(tmpHtml);
                    rows.push(newRow);

            });
            Plugin.container.html('');
            Plugin.container.append(rows);

            if(scrollAtBottom){
                Plugin.container.scrollTop(Plugin.container[0].scrollHeight)
            }

        });
        });
    };



    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );/**
 * Created by miguelgonzalez on 17/11/17.
 */
